<div class="topbar">
  <div class="topbar-left">
    <button
      class="topbar-hamburger"
      type="button"
      (skkClick)="toggleSidebar()"
      i18n-aria-label="@@topbar.menu.ariaLabel"
      aria-label="Open menu"
    >
      <i-lucide [img]="MenuIcon"></i-lucide>
    </button>

    @if (currentOrganization(); as org) {
      @if (switcherAvailable()) {
        <div class="mode-switcher">
          <button
            type="button"
            class="current-organization current-organization--switcher"
            (click)="toggleModeMenu()"
            i18n-aria-label="@@topbar.modeSwitcher.ariaLabel"
            aria-label="Switch portal"
          >
            <span class="current-organization-name">{{ org.name }}</span>
            <span class="current-organization-role">{{ currentRole() | lowercase }}</span>
            <i-lucide class="mode-switcher__chevron" [img]="SwitchIcon" [size]="15" />
          </button>
          @if (modeMenuOpen()) {
            <div class="mode-switcher__menu">
              <button type="button" class="mode-switcher__item" (click)="switchMode('producer')">
                <span i18n="@@topbar.modeSwitcher.producer">Producer portal</span>
                @if (!isPortal()) {
                  <i-lucide [img]="CheckIcon" [size]="15" />
                }
              </button>
              <button type="button" class="mode-switcher__item" (click)="switchMode('portal')">
                <span i18n="@@topbar.modeSwitcher.customer">Customer portal</span>
                @if (isPortal()) {
                  <i-lucide [img]="CheckIcon" [size]="15" />
                }
              </button>
            </div>
          }
        </div>
      } @else {
        <div class="current-organization">
          <span class="current-organization-name">{{ org.name }}</span>
          <span class="current-organization-role">{{ currentRole() | lowercase }}</span>
        </div>
      }
    }
  </div>

  <div class="topbar-right">
    <div class="current-user">
      <div class="user-avatar">
        {{ currentUser()?.firstName + ' ' + currentUser()?.lastName | initials }}
      </div>
      <div class="user-credentials">
        <span class="user-name">{{ currentUser()?.firstName }} {{ currentUser()?.lastName }}</span>
        <span class="user-email">{{ currentUser()?.email }}</span>
      </div>
    </div>

    <button class="logout-button" (skkClick)="logout()">
      <i-lucide [img]="LogOutIcon"></i-lucide>
    </button>
  </div>
</div>
